import { render, staticRenderFns } from "./taskProcess.vue?vue&type=template&id=440f4a1e&"
import script from "./taskProcess.vue?vue&type=script&lang=js&"
export * from "./taskProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports